import { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import CloseIcon from '@mui/icons-material/Close';

import { byteConverter } from 'src/utils/utility';
import IconDocumentTextGreen from 'src/assets/images/icons/document-text-green.svg';
import { ACCEPT_FILE } from 'src/config';

import { UploadInputRaw } from '../../atom/upload';
import { simplifyFileNames } from './tools';
import { useUploadUI } from './useUploadUI';

export const StepSelectInvoices = () => {
  const { invoiceFiles, setInvoiceFiles } = useUploadUI();

  /**
   * onDrop
   */
  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        const newFiles = [...invoiceFiles, ...acceptedFiles];
        setInvoiceFiles(newFiles);
      }
    },
    [invoiceFiles, setInvoiceFiles]
  );

  const dropzone = useDropzone({
    onDrop,
    multiple: true,
    accept: ACCEPT_FILE,
  });

  const onDeleteFile = useCallback(
    (index: number) => {
      const newFiles = [...invoiceFiles];
      if (index > -1) {
        newFiles.splice(index, 1);
      }
      setInvoiceFiles(newFiles);
    },
    [invoiceFiles, setInvoiceFiles]
  );

  return (
    <div className='relative'>
      <h3 className='text-16 xl:text-18 font-bold mb-2'>Select Invoices</h3>
      <p className='text-14 xl:text-16 font-normal text-blue_grey-80 mt-1'>Select invoices from this service provider and modality to be uploaded:</p>

      <div className='mt-24'>
        <UploadInputRaw dropzone={dropzone} className='!bg-[#E7EAF3] !border-[#DFDFDF]' />

        {invoiceFiles?.length > 0 && (
          <div className='mt-24 border border-neutral-20 rounded-8 p-24'>
            <div className='flex items-center mb-20'>
              <h4 className='font-medium text-18'>{invoiceFiles?.length} Items</h4>
              <button type='button' className='text-14 font-medium ml-auto text-red-40 underline' onClick={() => setInvoiceFiles([])}>
                Clear All
              </button>
            </div>

            <div className='flex flex-col gap-10'>
              {invoiceFiles.map((file: File, index: number) => (
                <div
                  key={`${file.name}-${file.size}-${file.lastModified}`}
                  className='flex items-center gap-12 p-16 bg-white border border-neutral-20 rounded-8'
                >
                  <img src={IconDocumentTextGreen} alt='' />
                  <strong className='text-16 font-medium'>{simplifyFileNames(file?.name)}</strong>

                  <div className='ml-auto flex items-center gap-12'>
                    <span className='text-12 text-neutral-60'>{byteConverter(file?.size)}</span>

                    <button aria-label='delete button' type='button' onClick={() => onDeleteFile(index)}>
                      <CloseIcon sx={{ fontSize: 20 }} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
